import { useState } from 'react';
import '@/App.css';
import { Menu, X, Upload } from 'lucide-react';

function Gallery() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="app-container">
      {/* Navigation */}
      <nav className="nav-bar">
        <div className="nav-content">
          <div className="nav-logo" data-testid="nav-logo">
            <img src="https://customer-assets.emergentagent.com/job_pe360-global/artifacts/7bbv220l_pharmaevents%20No%20Background%20%281%29-cropped%20%281%29.svg" alt="PharmaEvents360" />
          </div>
          
          {/* Desktop Navigation */}
          <div className="nav-links-desktop">
            <button onClick={() => window.location.href = '/'} data-testid="nav-home">Home</button>
            <button onClick={() => window.location.href = '/#about'} data-testid="nav-about">About</button>
            <button onClick={() => window.location.href = '/#technology'} data-testid="nav-technology">Technology</button>
            <button onClick={() => window.location.href = '/#expertise'} data-testid="nav-expertise">Expertise</button>
            <button onClick={() => window.location.href = '/#global'} data-testid="nav-global">Global Reach</button>
            <button onClick={() => window.location.href = '/gallery'} data-testid="nav-gallery">Gallery</button>
            <button onClick={() => window.location.href = '/#contact'} data-testid="nav-contact">Contact</button>
          </div>

          {/* Mobile Menu Button */}
          <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-testid="mobile-menu-btn">
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="nav-links-mobile" data-testid="mobile-menu">
            <button onClick={() => window.location.href = '/'}>Home</button>
            <button onClick={() => window.location.href = '/#about'}>About</button>
            <button onClick={() => window.location.href = '/#technology'}>Technology</button>
            <button onClick={() => window.location.href = '/#expertise'}>Expertise</button>
            <button onClick={() => window.location.href = '/#global'}>Global Reach</button>
            <button onClick={() => window.location.href = '/gallery'}>Gallery</button>
            <button onClick={() => window.location.href = '/#contact'}>Contact</button>
          </div>
        )}
      </nav>

      {/* Gallery Section */}
      <section className="gallery-page" data-testid="gallery-page">
        <div className="section-container">
          <h1 className="gallery-title" data-testid="gallery-title">Gallery</h1>
          <div className="gallery-divider"></div>
          
          <div className="gallery-placeholder" data-testid="gallery-placeholder">
            <div className="gallery-placeholder-content">
              <p className="gallery-placeholder-text">Our past event moments will appear here soon.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer" data-testid="footer">
        <p>© 2025 <span style={{ color: '#AD7900' }}>PE360</span> | Global Event Solutions Partner</p>
      </footer>
    </div>
  );
}

export default Gallery;
